import React from 'react';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Button, Result, Typography } from 'antd';
import { withRouter } from 'react-router-dom';
import style from './index.module.less';

const { Paragraph, Text } = Typography;

export const NoAuth = withRouter((props) => {
  const { history } = props;
  return (
    <div className={style.home}>
      <Result
        status="403"
        title="403"
        subTitle="抱歉，您无权限访问该页面！"
        extra={
          <Button type="primary" onClick={() => history.replace('/')}>
            返回首页
          </Button>
        }
      />
    </div>
  );
});

export const NoMatch = withRouter((props) => {
  const { history } = props;
  return (
    <div className={style.home}>
      <Result
        status="404"
        title="404"
        subTitle="抱歉，您访问的页面不存在！"
        extra={
          <Button type="primary" onClick={() => history.replace('/')}>
            返回首页
          </Button>
        }
      />
    </div>
  );
});

export const PageError = withRouter((props) => {
  const { history, error } = props;
  return (
    <Result
      status="error"
      title="抱歉，您访问的页面出现故障！"
      subTitle="请将下方错误信息反馈给开发人员"
      extra={[
        <Button key="back" type="primary" onClick={() => history.replace('/')}>
          返回首页
        </Button>,
        <Button key="reload" onClick={() => window.location.reload()}>
          重试
        </Button>,
      ]}
    >
      <div className="desc">
        <Paragraph>
          <Text
            strong
            style={{
              fontSize: 16,
            }}
          >
            错误信息:
          </Text>
        </Paragraph>
        <Paragraph>
          <p>
            <CloseCircleOutlined style={{ color: 'red' }} />
            &nbsp;
            {error}
          </p>
        </Paragraph>
      </div>
    </Result>
  );
});

export default {};
